import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "question-circle_icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 19a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 19m1.6-6.08a1 1 0 0 0-.6.917 1 1 0 1 1-2 0 3 3 0 0 1 1.8-2.75A2 2 0 1 0 10 9.255a1 1 0 1 1-2 0 4 4 0 1 1 5.6 3.666Z" })
});
export { SvgQuestionCircle as ReactComponent };
